/** @jsxImportSource react */
import EntityTile from '@react/card';
import { useEvents } from '@react/services/events';
import { arrayOf, bool, func, object, string } from 'proptypes';
import { useEffect } from 'react';

const SimilarCommunities = ({ communities, city, state }) => {
  const { sendCommunityListViewedEvent } = useEvents();

  useEffect(() => {
    sendCommunityListViewedEvent(
      communities,
      city,
      state,
      'similar communities'
    );
  }, []);

  return (
    <>
      {communities.map((community) => (
        <EntityTile key={community.id} entity={community} intent='vertical' />
      ))}
    </>
  );
};

SimilarCommunities.propTypes = {
  communities: arrayOf(object),
  onCommunityClick: func,
  eventProps: object,
  communityStyle: object,
  canFavourite: bool,
  city: string,
  state: string,
};

SimilarCommunities.defaultProps = {
  onCommunityClick: () => {},
  eventProps: {},
  canFavourite: false,
};

export default SimilarCommunities;
